import React from 'react';
import toUpper from 'lodash/toUpper';

const LangSign = lang => {
	switch (lang) {
		case 'ru': return <span className="flag-icon flag-icon-ru" title={lang}/>;
		case 'uk': return <span className="flag-icon flag-icon-ua" title={lang}/>;
		case 'en': return <span className="flag-icon flag-icon-gb" title={lang}/>;
		case 'de': return <span className="flag-icon flag-icon-de" title={lang}/>;
		case 'vi': return <span className="flag-icon flag-icon-vn" title={lang}/>;
		case 'th': return <span className="flag-icon flag-icon-th" title={lang}/>;
		default: return <span className="flag-icon">{toUpper(lang)}</span>;
	}
};

export default LangSign;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/utils/get-lang-sign.js